import * as React from 'react';
function useInterval(callback, timeout) {
    const savedCallback = React.useRef(callback);
    const handler = React.useCallback(() => savedCallback.current(new Date().getTime()), []);
    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    React.useEffect(() => {
        if (timeout) {
            const id = window.setInterval(handler, timeout);
            return () => window.clearInterval(id);
        }
        else {
            return undefined;
        }
    }, [handler, timeout]);
}
export default useInterval;
//# sourceMappingURL=useInterval.js.map